import React from "react"
import styled from "styled-components"

const Term = styled.span`
  display: inline-block;
  position: relative;
  width: fit-content;
`

const Definition = styled.div`
  display: inline-block;
  position: absolute;
  left: 0;
  top: 2rem;
  background-color: var(--color-background-24-dp-elevation);
  padding: 1rem;
  border-radius: 1rem;
  z-index: 200;
  border-width: 4px 1px 1px 1px;
  border-style: solid;
  box-shadow: 0px 0px 8px 2px rgb(0 0 0 / 13%);
  border-color: var(--color-theme-accent);
  width: min(80vw, 400px);
  /* visibility: hidden; */
  /* not working on small screens */
`

function DefineTerm(props) {
  return (
    <Term>
      {props.term}
      <Definition>{props.children}</Definition>
    </Term>
  )
}

export default DefineTerm
